"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.IRewardsDistributer__factory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "indexer",
                type: "address",
            },
            {
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "era",
                type: "uint256",
            },
        ],
        name: "addInstantRewards",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "indexer",
                type: "address",
            },
        ],
        name: "claim",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "indexer",
                type: "address",
            },
            {
                internalType: "address",
                name: "user",
                type: "address",
            },
        ],
        name: "claimFrom",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "era",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "indexer",
                type: "address",
            },
        ],
        name: "collectAndDistributeEraRewards",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "indexer",
                type: "address",
            },
        ],
        name: "collectAndDistributeRewards",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "indexer",
                type: "address",
            },
        ],
        name: "getRewardInfo",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "accSQTPerStake",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "lastClaimEra",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "eraReward",
                        type: "uint256",
                    },
                ],
                internalType: "struct IndexerRewardInfo",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "agreementId",
                type: "uint256",
            },
        ],
        name: "increaseAgreementRewards",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "indexer",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "era",
                type: "uint256",
            },
        ],
        name: "resetEraReward",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "indexer",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "era",
                type: "uint256",
            },
        ],
        name: "setLastClaimEra",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "indexer",
                type: "address",
            },
            {
                internalType: "address",
                name: "delegator",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "setRewardDebt",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "indexer",
                type: "address",
            },
            {
                internalType: "address",
                name: "user",
                type: "address",
            },
        ],
        name: "userRewards",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
class IRewardsDistributer__factory {
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.IRewardsDistributer__factory = IRewardsDistributer__factory;
IRewardsDistributer__factory.abi = _abi;
